module.exports = require("@fullcalendar/daygrid");